export class TypesObject {
    static readonly typesObject = [
        { id: 2, name: 'Многоквартирный дом', title_en: 'Multi-storey building' },
        { id: 1, name: 'Торговый/бизнес центр', title_en: 'Shopping/business center' },
        { id: 3, name: 'Частный дом', title_en: 'A private house' },
        { id: 4, name: 'Образовательное учреждение', title_en: 'Education institution' },
        { id: 11, name: 'Медицинское учреждение' , title_en: 'Medical institution'},
        { id: 12, name: 'Государственное учреждение' , title_en: 'Government agency'},
        // { id: 5, name: 'СОШ', title_en: 'Secondary school' },
        // { id: 6, name: 'ВУЗ', title_en: 'University' },
        { id: 7, name: 'Производство', title_en: 'Production' },
        { id: 8, name: 'Трансформаторная подстанция', title_en: 'Transformer substation'},
        { id: 9, name: 'Колодец', title_en: 'Well' },
        { id: 10, name: 'Скважина' , title_en: 'Pore'},
        { id: 13, name: 'Теплоисточник' , title_en: 'Heat source'},
    ];
    static readonly typesInnerObject = [
        { id: 100, name: 'Квартира', title_en: 'Flat' },
        { id: 101, name: 'Офис', title_en: 'Office' },
        { id: 102, name: 'Цех', title_en: 'Manufactory' },
        { id: 103, name: 'Подобъект для ОДПУ', title_en: 'Sub-object for GHMD' },
        { id: 104, name: 'Прочее', title_en: 'Other' }
    ];
}
